let executor = 0;
export default class DelayedExecution{
    constructor(callback, delay=200) {
        this.callback = callback;
        this.execTimer = null;
        this.execInProgress = false;

        this.delay = delay;
        this.paused = false;
        this.executorId = executor++;
    }

    abortExecution(){
        if(this.execTimer) {
            clearTimeout(this.execTimer);
            this.execTimer = null;
        }
        this.reExec = false;
        this.paused = false;
    }

    pauseExecution(){
        if(this.execTimer) {
            clearTimeout(this.execTimer);
            this.execTimer = null;
            this.paused = true;
        }
        this.reExec = false;
    }

    resumeExecution(){
        if(this.paused){
            this.scheduleExecution();
        }
    }

    scheduleExecution(){
        if(this.execTimer){
            this.abortExecution();
        }

        if(this.execInProgress){
            this.reExec = true;
            return;
        }

        this.paused = false;
        this.execTimer = setTimeout(async () => {
            this.execTimer = null;
            this.execInProgress = true;
            try{
                await this.callback();
                while(this.reExec) {
                    await this.callback();
                    this.reExec = false;
                }
            } finally {
                this.execInProgress = false;
            }
        }, this.delay);
    }
}